import React from 'react';
import { purple } from 'globals/colors';

interface FsFilterArrowIconProps {
  color?: string;
}

const FsFilterArrowIcon: React.FC<FsFilterArrowIconProps> = ({
  color = purple.BRAND,
}) => {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4848 6.24264L6.24219 10.4853L1.99955 6.24264"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default FsFilterArrowIcon;
